import React, { Component } from "react";

import Modal from "react-bootstrap/Modal";

import UBXButton from "../../ubx/button";

export default class ResponseModal extends Component {
    // constructor(props) {
    //     super(props);
    // }

    closeModal(e) {
        const { onClose = false } = this.props;

        if (onClose) {
            onClose(e);
        }
    }

    onConfirm(e) {
        const { onConfirm = false } = this.props;

        if (onConfirm) {
            onConfirm(e);
        }
    }

    render() {
        const {
            show = false,
            title,
            header,
            message,
            iconSrc = false,
            actionLabel = "Continue",
            referenceNumber = false,
            onConfirm = false,
        } = this.props;

        let referenceNumberText = "";
        if (referenceNumber) {
            referenceNumberText = <strong>Ref# {referenceNumber}</strong>;
        }

        return (
            <Modal id="response-modal" show={show} backdrop="static" centered onHide={(e) => this.closeModal(e)}>
                <Modal.Header closeButton closeLabel="Close Response Modal">
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div id="response-body">
                        <div id="response-content">
                            <div className={`w-100 ${iconSrc ? "" : "text-center"}`}>
                                <p>{header}</p>
                                <span>{message}</span>
                                {referenceNumberText}
                            </div>
                            {iconSrc && (
                                <div className="icon">
                                    <img src={iconSrc} alt="Modal Icon" />
                                </div>
                            )}
                        </div>
                        <div id="response-action">
                            {onConfirm && (
                                <div className="user-fields">
                                    <UBXButton
                                        id="response-button"
                                        type="primary"
                                        block={true}
                                        onClick={() => this.onConfirm()}
                                        size="large"
                                    >
                                        {actionLabel}
                                    </UBXButton>
                                </div>
                            )}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}
